import { REPORT_STATUS_ID_ENABLED } from '@/enum/reportStatuses'
import store from '@/store/store'

const currentAccount = store.getters['entities/getCurrentAccount']

export const setTimezoneData = () => {
    return {
        timezone: {
            timezoneName: null,
            timezoneStatus: 0,
            GmtOffset: (currentAccount && currentAccount.GmtOffset) || 108000
        }
    }
}

const defaultReportData = {
    LayoutID: null,
    AccountID: null,
    ReportName: null,
    ReportTypeID: 1,
    ReportItemList: [],
    ReportStatusID: REPORT_STATUS_ID_ENABLED,
    ReportTriggerList: [],
    ReportConf: setTimezoneData()
}

export const setDefaultReportData = () => {
    return JSON.parse(JSON.stringify(defaultReportData))
}

const defaultReportConditionData = {
    WidgetID: null,
    WidgetTemplateColumnID: null,
    ConditionFilterOperatorID: null,
    ConditionFilterColumnTypeID: null,
    ConditionFilterValue: null
}
export const setDefaultReportConditionData = () => {
    return JSON.parse(JSON.stringify(defaultReportConditionData))
}
const defaultReportTriggerData = {
    ReportTriggerTypeID: 1,
    ReportTriggerName: '',
    ReportID: '',
    EmailSubject: '',
    EmailBody: '',
    ReportTriggerRecipient: [],
    ScheduleData: {},
    ReportTriggerCondition: [
        {
            ReportTriggerConditionFilter: [
                setDefaultReportConditionData()
            ]
        }
    ]
}

export const setDefaultReportTriggerData = () => {
    return JSON.parse(JSON.stringify(defaultReportTriggerData))
}
